import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DateMetricCard } from "@radarly/models/cards";
import { DatavizKpi } from "@radarly/models/dataviz";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import Kpi from "@radarly/shared/widgets/date-metric/kpi";
import { CardFragmentsProps } from "../model";

const RadarlyMetricCardKPI = ({
  title,
  fragments,
  project,
  dataviz,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentsProps<DateMetricCard["fragments"], DatavizKpi>) => {
  const fragment = fragments[0];
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={fragment.request.aggs.date.metrics[0]} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <Kpi
        fragment={fragments[0]}
        evolutionFragment={fragments[1]}
        project={project.id}
        dataviz={dataviz}
        onClick={onClickItem ? () => onClickItem(null) : null}
        forceReload={forceReload}
        nowDate={nowDate}
      />
    </Tile>
  );
};

export default RadarlyMetricCardKPI;
